import { GetterTree } from 'vuex';
import { State } from '@/manager/employee/store/state';

export const getters: GetterTree<State, any> = {
    getEmployeeList: (state) => state.list,
    getEmployee(state: State) {
        return (id: string) => {
            return state.list.find(
                (employee: any) => {
                    return employee.user.id === id;
                },
            );
        };
    },
};
